import type { ChangeEventHandler, RefObject } from "react";

interface CapturePanelProps {
	cameraOn: boolean;
	error: string;
	image: string | null;
	loading: boolean;
	videoRef: RefObject<HTMLVideoElement | null>;
	onAnalyze: () => void;
	onCapture: () => void;
	onReset: () => void;
	onStartCamera: () => void;
	onUpload: ChangeEventHandler<HTMLInputElement>;
}

export function CapturePanel({
	cameraOn,
	error,
	image,
	loading,
	videoRef,
	onAnalyze,
	onCapture,
	onReset,
	onStartCamera,
	onUpload,
}: CapturePanelProps) {
	return (
		<div className="capture-card">
			<div className="step">
				<span>01</span>
				<div>
					<strong>Đưa thực phẩm vào khung hình</strong>
					<small>Đủ sáng, các đối tượng rõ nét và không che nhau</small>
				</div>
			</div>

			<div className={`viewer ${image ? "has-image" : ""}`}>
				{image ? (
					<img src={image} alt="Ảnh thực phẩm đã chụp" />
				) : (
					<>
						<video
							ref={videoRef}
							autoPlay
							playsInline
							muted
							className={cameraOn ? "visible" : ""}
							aria-label="Hình ảnh trực tiếp từ camera"
						/>
						{!cameraOn && (
							<div className="empty-state">
								<span className="camera-icon">⌾</span>
								<p>Camera chưa được bật</p>
								<small>Ảnh chỉ được gửi khi bạn bấm “Phân tích”</small>
							</div>
						)}
					</>
				)}
				{cameraOn && <div className="focus-frame" aria-hidden="true" />}
			</div>

			{error && (
				<div className="error" role="alert">
					{error}
				</div>
			)}

			<div className="actions">
				{!cameraOn && !image && (
					<button type="button" className="primary" onClick={onStartCamera}>
						Mở camera <span>→</span>
					</button>
				)}
				{cameraOn && (
					<button type="button" className="primary" onClick={onCapture}>
						Chụp ảnh <span>●</span>
					</button>
				)}
				{image && (
					<button
						type="button"
						className="primary"
						onClick={onAnalyze}
						disabled={loading}
					>
						{loading ? "AI đang phân tích…" : "Phân tích thực phẩm"}{" "}
						<span>→</span>
					</button>
				)}
				<label className="secondary">
					Tải ảnh lên
					<input type="file" accept="image/*" onChange={onUpload} />
				</label>
				{(image || cameraOn) && (
					<button type="button" className="text-button" onClick={onReset}>
						Làm lại
					</button>
				)}
			</div>
		</div>
	);
}
